import Colors from '../../../../shared/assets/style/default/color';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';

function RewindIcon({ height, width }: Props) {
  return (
    <svg
      clipRule={'evenodd'}
      fill={`${Colors['light']}`}
      fillRule={'evenodd'}
      height={`${height || 56 * Screen.widthRatio}`}
      width={`${width || 92 * Screen.widthRatio}`}
      xmlns={'http://www.w3.org/2000/svg'}
      viewBox={'0 0 92 56'}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M45.9661 55.031C44.1886 56.1879 41.8033 56.4063 39.7038 55.1527L39.7012 55.1511L2.81261 33.073C0.862318 31.9064 5.34386e-06 29.8568 5.18153e-06 28C5.01921e-06 26.1432 0.862317 24.0936 2.81261 22.927L39.7038 0.847329C41.8033 -0.406352 44.1886 -0.187896 45.9661 0.968945C47.7182 2.10929 48.8549 4.12109 48.8549 6.423L48.8549 49.577C48.8549 51.8789 47.7182 53.8907 45.9661 55.031ZM42.7296 49.9711C42.7799 49.9186 42.8549 49.8014 42.8549 49.577L42.8549 6.423C42.8549 6.19859 42.7799 6.08137 42.7296 6.02892L6.01981 28L42.7296 49.9711Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M88.9661 55.031C87.1886 56.1879 84.8033 56.4063 82.7038 55.1527L82.7012 55.1511L45.8126 33.073C43.8623 31.9064 43 29.8568 43 28C43 26.1432 43.8623 24.0936 45.8126 22.927L82.7038 0.847325C84.8033 -0.406356 87.1886 -0.1879 88.9661 0.968941C90.7182 2.10928 91.8549 4.12108 91.8549 6.42299L91.8549 49.577C91.8549 51.8789 90.7182 53.8907 88.9661 55.031ZM85.7296 49.9711C85.7799 49.9186 85.8549 49.8014 85.8549 49.577L85.8549 6.42299C85.8549 6.19858 85.7799 6.08137 85.7296 6.02891L49.0198 28L85.7296 49.9711Z'
        fill='white'
      />
    </svg>
  );
}

export default RewindIcon;
